<template>
  <v-container fluid tag="section">
    <validation-observer ref="observer" v-slot="{ invalid }">
      <base-material-card inline icon="mdi-poll" color="primary" class="ml-0 px-5 py-4">
        <template v-slot:after-heading>
          <div class="display-2 font-weight-light">
            {{ title }}
          </div>
        </template>
        <v-form class="pt-5">
          <parametros ref="parametrosREF" />
          <v-row>
            <v-col cols="12">
              <v-btn
                id="btn-save-indicador-prazo"
                color="success"
                min-width="100"
                style="float: right"
                class="mr-0 mt-5"
                :disabled="invalid"
                :loading="loading"
                @click="save()"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </base-material-card>
    </validation-observer>
  </v-container>
</template>
  
<script>
  import TesteQtdMatServService from '@/services/TesteQtdMatServService';

  export default {
    components: {
      Parametros: () => import('@/components/testeQtdMatServ/Parametros.vue')
    },

    data: () => ({
      loading: false
    }),

    computed: {
      title() {
        return this.$route.params.id ? 'Editando Teste' : 'Adicionar Teste';
      }
    },

    methods: {
      save() {
        const id = this.$route.params.id ?? null;
        const data = this.$refs.parametrosREF.exportData();
        this.loading = true;

        TesteQtdMatServService.salvar(data, id)
          .then(() => {
            this.$toast.success('Teste salvo com sucesso.', '', { position: 'topRight' });
            this.$router.replace({ name: 'QTD Materal x Serviços Histórico' });
          })
          .catch((err) => {
            console.error(err);
            this.$toast.error('Erro ao salvar o teste.', '', {
              position: 'topRight'
            });
          })
          .finally(() => (this.loading = false));
      }
    }
  };
</script>
  